export default function login(state = "", action) {
    switch (action.type) {
        case "SET_CHAT_LOG":
            return action.payload;
        default:
            return state;
    }
}
